import { Fetcher } from '@this/src/util';

type PaymentFormResponse = {
  success: boolean;
  message_id?: number;
  error?: string;
};

export type PaymentFormResult = {
  success: boolean;
  messageId?: number;
  error?: string;
};

const convertResponse = (response: PaymentFormResponse): PaymentFormResult => ({
  success: response.success,
  messageId: response.message_id,
  error: response.error
});

export const createPaymentForm = async (tripId: string): Promise<PaymentFormResult> => {
  const response = await Fetcher.post<PaymentFormResponse>(`/trips/${tripId}/ai_payment_form`, {});
  return convertResponse(response);
};
